/*
 * Jira Ticket:
 * Created Date: Wed, 11th Mar 2020, 12:06:24 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import {
  Create,
  required,
  SimpleForm,
  SelectInput,
  TextInput,
} from 'react-admin';
import { columnStyles } from 'styles';
import { booleanOptions } from 'utils/choices';
import { isSuperAdmin } from 'utils/roles';
import { isValidPhoneNumber, isValidEmail } from 'utils/validation';

const SanitizedForm = ({ permissions }) => {
  const classes = columnStyles();
  const canEdit = isSuperAdmin(permissions);

  const emailValidation = [required(), email => isValidEmail(email)];

  return (
    <div className={classes.root}>
      <div className={classes.column}>
        <TextInput
          source="name"
          validate={required()}
          label={'resources.Organisation.fields.orgName'}
        />
        {/* <SelectInput
          source="checklistRequired"
          label={'resources.Organisation.fields.checkList'}
          choices={booleanOptions}
          defaultValue={true}
          validate={required()}
        /> */}
        <SelectInput
          source="projectAccess"
          label={'resources.Organisation.fields.projectAccess'}
          defaultValue={true}
          disabled={!canEdit}
          validate={required()}
          choices={booleanOptions}
        />
      </div>
      <div className={classes.column}>
        <TextInput
          source="contact.name"
          validate={required()}
          label={'resources.Organisation.fields.pocName'}
        />
        <TextInput
          source="contact.position"
          validate={required()}
          label={'resources.Organisation.fields.pocPosition'}
        />
        <TextInput
          source="contact.email"
          validate={emailValidation}
          label={'resources.Organisation.fields.pocEmail'}
        />
        <TextInput
          source="contact.phone"
          validate={phone => isValidPhoneNumber(phone)}
          label={'resources.Organisation.fields.pocNum'}
        />
      </div>
      <div className={classes.column}>
        <TextInput
          source="addressLine1"
          validate={required()}
          label={'resources.Organisation.fields.addressOne'}
        />
        <TextInput
          source="addressLine2"
          label={'resources.Organisation.fields.addressTwo'}
        />
        <TextInput
          source="city"
          validate={required()}
          label={'resources.Organisation.fields.city'}
        />
        <TextInput
          source="postCode"
          validate={required()}
          label={'resources.Organisation.fields.postcode'}
        />
        <TextInput
          source="country"
          validate={required()}
          label={'resources.Organisation.fields.country'}
        />
      </div>
    </div>
  );
};

const OrganisationCreate = props => {
  return (
    <Create title={'resources.Organisation.fields.createTitle'} {...props}>
      <SimpleForm>
        <SanitizedForm {...props} />
      </SimpleForm>
    </Create>
  );
};
export default OrganisationCreate;
